import PropTypes from "prop-types";
import React from "react";

const Image = ({ src, style }) => {
  return (
    <img
      src={src}
      style={{ width: "100%", height: "100%", objectFit: "cover", ...style }}
      alt="logoImage"
    />
  );
};

export default Image;
Image.propTypes = {
  src: PropTypes.any,
  style: PropTypes.object,
};
